export const objectToQueryString = <T>(v: T) =>
  (Object.keys(v as any) as Array<keyof typeof v>)
    .reduce((queryParams: string[], key) => {
      const value = v[key];

      if (Array.isArray(value)) {
        return [
          ...queryParams,
          value.map((v) => `${key as string}=${v}`).join('&'),
        ];
      }

      if (typeof value === 'object') {
        return [
          ...queryParams,
          Object.keys(value as any)
            .map(
              (v) =>
                `${key as string}.${v}=${
                  (value as any)[v as keyof typeof value]
                }`,
            )
            .join('&'),
        ];
      }

      if (value) {
        return [...queryParams, `${key as string}=${value}`];
      }

      return queryParams;
    }, [])
    .filter((v) => v)
    .join('&');

export const getEnv = () =>
  window?.location?.hostname?.toLowerCase().includes('localhost')
    ? 'dev'
    : (window?.location?.hostname
        ?.split('.')[0]
        ?.split('-')[2]
        ?.toLowerCase() ?? 'production');
